import { swiperConfig } from '../lib/swiper-config'
export let SwiperMixins = {
    data: {
        swiperOption: {
            ...swiperConfig,
            slidesPerView: 1,
            spaceBetween: 10,
            slidesPerGroup: 4,
            loop: false,
            loopFillGroupWithBlank: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 4
                },
            }
        },
        swiperHomeContentOption: {
            ...swiperConfig,
            slidesPerView: 1,
            spaceBetween: 10,
            slidesPerGroup: 1,
            loop: false,
            loopFillGroupWithBlank: false,
            navigation: {
                nextEl: '.swiper-next-btn',
                prevEl: '.swiper-prev-btn'
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                992: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
            pagination: {
                el: '.swiper-pagination.sr-only',
                clickable: true
            },
        },
        swiperOptionsCompanies: {
            ...swiperConfig,
            slidesPerView: 1,
            slidesPerGroup: 4,
            spaceBetween: 20,
            loop: true,
            loopFillGroupWithBlank: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            navigation: {
                nextEl: '.swiper-next-btn',
                prevEl: '.swiper-prev-btn'
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 4
                },
            },
            pagination: {
                el: '.swiper-pagination.sr-only',
                clickable: true
            },
        },
        swiperOptionsHome: {
            ...swiperConfig,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            loop: true,
            loopFillGroupWithBlank: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        }
    }
}